// auth
export const AuthHeadingText = ({ text, className, color }) => {
  return <h1 className={`auth-heading ${className}`}>{text}</h1>;
};
// auth
export const TextBasic = ({ text, className, color, onClick }) => {
  return <p className={`text-basic ${className} ${color ? color : 'primary-color'}`} onClick={onClick}>{text}</p>;
};

// Forgot Password
export const SimpleBasic = ({ text, className, color }) => {
  return <p className={`simple-basic ${className} ${color ? color : 'primary-color'}`}>{text}</p>;
};

export const PageHeading = ({ text, count, className }) => {
  return (
    <div className="page-heading-component d-flex align-items-center gap-2">
      <p className={`page-heading ${className}`}>{text}</p>
      {count && <p className="count">{`(${count})`}</p>}
    </div>
  );
};

export const ExtraBoldText = ({ text, className }) => {
  return <div className={`extra-bold-text ${className}`}>{text}</div>;
};
